import { render, staticRenderFns } from "./BundleDetails.vue?vue&type=template&id=4ba3d72a&scoped=true&"
import script from "./BundleDetails.vue?vue&type=script&lang=js&"
export * from "./BundleDetails.vue?vue&type=script&lang=js&"
import style0 from "./BundleDetails.vue?vue&type=style&index=0&id=4ba3d72a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba3d72a",
  null
  
)

export default component.exports